import {
  PREPAID_BY_DAY,
  PREPAID_BY_DAY_ERROR,
  CLEAN_PREPAID_BY_DAY,
  CLEAN_PREPAID_BY_DAY_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function prepaidByDayReducer(state = initialState, action) {
  switch (action.type) {
    case PREPAID_BY_DAY:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PREPAID_BY_DAY_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_PREPAID_BY_DAY:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PREPAID_BY_DAY_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
